import { Card, FormControl, FormLabel, IconButton, TextField } from "@mui/material"
import {Remove, Add} from '@mui/icons-material';
import { FieldProps } from "@rjsf/core";
import { useEffect, useState } from "react";
import './styles/quantity.scss';

export const Quantity = (props: FieldProps<number>) => {
    
    const [value, setValue] = useState<number>(props.formData || 0)
    const { allowNegative, max, min } = (props.uiSchema['ui:options'] || {}) as QuantityUiOption

    useEffect(() => {
        let val = value

        if (allowNegative === false && value < 0) {
            val = 0
        }

        if (max && value > max) {
            val = max
        }

        if (min && value < min) {
            val = min
        }
        
        if (val !== value) {
            setValue(val)
        }

        props.onChange(val)
    }, [value, allowNegative])

    useEffect(() => {
        if (props.formData !== value) {
            setValue(props.formData)
        }
    }, [props.formData])

    const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const num = parseInt(e.currentTarget.value)
        setValue((v) => isNaN(num) ? v : num)
    }

    const handleRemoveClick = () => {
        setValue((v) => (v - 1))
    }

    const handleAddClick = () => {
        setValue((v) => (v + 1))
    }

    return (
        <FormControl component="fieldset" className="control-quantity">
            <FormLabel component="legend">{ props.title }</FormLabel>

            <Card className="control-quantity-container" variant="outlined">
                <IconButton
                    color="primary"
                    component="span"
                    disabled={Boolean((allowNegative === false && value === 0) || (min && value <= min))}
                    onClick={handleRemoveClick}>
                    <Remove />
                </IconButton>
                <TextField
                    type="text"
                    value={value}
                    onChange={handleTextFieldChange}
                    />
                <IconButton
                    color="primary"
                    component="span"
                    disabled={Boolean(max && value >= max)}
                    onClick={handleAddClick}>
                    <Add />
                </IconButton>
            </Card>
        </FormControl>
    );
}

export type QuantityUiOption = {
    allowNegative?: boolean

    max?: number

    min?: number
}
